import IR_REM1remote from './IR_REM-1-remote.js';
import SHSPOT1 from './SHSPOT-1.js';
import SHPSW04P from './SHPSW04P.js';
export const Prototypes = {
	'IR_REM-1-remote': IR_REM1remote,
	'SHSPOT-1': SHSPOT1,
	SHPSW04P: SHPSW04P,
};
